import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { MDXProvider } from '@mdx-js/react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { useMDXScope } from 'gatsby-plugin-mdx/context';
import React, { useMemo } from 'react';
import BasePre from './Pre';
export default function Example(_ref) {
  var example = _ref.example,
      name = _ref.name;
  var scope = useMDXScope();
  var pre = useMemo(function () {
    return function (props) {
      return /*#__PURE__*/React.createElement(BasePre, Object.assign({}, props, {
        name: name
      }));
    };
  }, [name]);
  return example ? /*#__PURE__*/React.createElement(MDXProvider, {
    components: {
      pre: pre
    }
  }, /*#__PURE__*/React.createElement(MDXRenderer, {
    scope: _objectSpread({
      frontmatter: example.frontmatter
    }, scope)
  }, example.body)) : null;
}
export var fragment = "1442872208";